// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-2933bff0] .el-tabs {\n  height: 100%;\n  position: relative;\n}\n[data-v-2933bff0] .el-tabs__content {\n  position: absolute;\n  width: 100%;\n  height: calc(100vh - 135px)\n}\n[data-v-2933bff0] .el-tab-pane {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
